export const VIDEO_PRODUCTION_JOB_STATUS = {
  SUBMITTING: 'Submitting',
  SUBMITTED: 'Submitted',
  INIT: 'Init',
  QUEUING: 'Queuing',
  PROCESSING: 'Processing',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  SUBMIT_FAILED: 'SubmitFailed',
};

export const VIDEO_PRODUCTION_JOB_STATUS_LABELS = {
  [VIDEO_PRODUCTION_JOB_STATUS.SUBMITTING]: '提交中',
  [VIDEO_PRODUCTION_JOB_STATUS.SUBMITTED]: '已提交',
  [VIDEO_PRODUCTION_JOB_STATUS.INIT]: '初始化',
  [VIDEO_PRODUCTION_JOB_STATUS.QUEUING]: '排队中',
  [VIDEO_PRODUCTION_JOB_STATUS.PROCESSING]: '生成中',
  [VIDEO_PRODUCTION_JOB_STATUS.SUCCESS]: '成功',
  [VIDEO_PRODUCTION_JOB_STATUS.FAILED]: '失败',
  [VIDEO_PRODUCTION_JOB_STATUS.SUBMIT_FAILED]: '提交失败',
};

export const VIDEO_TEMPLATE_STATUS = {
  AVAILABLE: 'Available',
  CREATED: 'Created',
  UPLOADING: 'Uploading',
  PROCESSING: 'Processing',
  UPLOAD_FAILED: 'UploadFailed',
  PROCESS_FAILED: 'ProcessFailed',
};

export const VIDEO_TEMPLATE_TYPE = {
  TIMELINE: 'Timeline',
  VE_TEMPLATE: 'VETemplate',
};

export const VIDEO_PRODUCTION_SLOT_KIND = {
  IMAGE: 'image',
  VIDEO: 'video',
  TEXT: 'text',
};

export const VIDEO_TEXT_FIT_RUNTIME_LIMITS = {
  reference_size: { min: 1, max: 1000 },
  max_chars_per_line: { min: 1, max: 1000 },
  max_lines: { min: 1, max: 1000 },
};

export const VIDEO_MATERIAL_MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  FONT: 'font',
};

export const VIDEO_PRODUCTION_DEFAULT_ADAPT_TYPE = 2;

export const VIDEO_PRODUCTION_ADAPT_TYPE_OPTIONS = [
  { value: '0', label: '0 不适配' },
  { value: '1', label: '1 居中填满' },
  { value: '2', label: '2 完整居中显示' },
  { value: '3', label: '3 不等比缩放' },
];

export const ALIYUN_BUILT_IN_FONT_OPTIONS = [
  { value: 'FZFangSong-Z02S', label: '方正仿宋简体' },
  { value: 'FZHei-B01S', label: '方正黑体简体' },
  { value: 'FZKai-Z03S', label: '方正楷体简体' },
  { value: 'FZShuSong-Z01S', label: '方正书宋简体' },
  { value: 'SimSun', label: '宋体' },
  { value: 'WenQuanYi MicroHei', label: '文泉驿微米黑' },
  { value: 'WenQuanYi Zen Hei Mono', label: '文泉驿等宽正黑' },
  { value: 'WenQuanYi Zen Hei Sharp', label: '文泉驿点阵正黑' },
  { value: 'Microsoft YaHei', label: '微软雅黑' },
  { value: 'Yuanti SC', label: '圆体-简常规体' },
  { value: 'Alibaba PuHuiTi', label: '阿里巴巴普惠体' },
  { value: 'KaiTi', label: '楷体' },
  { value: 'Source Han Sans CN', label: '思源黑体' },
  { value: 'Source Han Serif CN', label: '思源宋体' },
  { value: 'HappyZcool-2016', label: '站酷快乐体' },
];
